export default __webpack_public_path__ + "static/media/2020_1.b27e0b28.PNG";